import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegisterPage } from './register/register.page';
import { LoginPage } from './login/login.page';
import { LogoutPage } from './logout/logout.page';
import { FarmerPage } from '../main/farmer/farmer.page';
import { PasswordResetPage } from './password-reset/password-reset.page';

export const AccountsRoutingModule_routes: Routes = [
  {
    path: '',
    component: FarmerPage
  },
  {
    path: 'register',
    component: RegisterPage
  },
  {
    path: 'password-reset',
    component: PasswordResetPage
  },
  {
    path: 'login',
    component: LoginPage
  },
  {
    path:'logout',
    component: LogoutPage
  }
];

